import { Wording } from '@/types';

export const LOVE_WORDING_BA: Wording = {
  components_header_media_content: 'Audio zapisi',
  components_header_media_1: 'Meditacije',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Vodiči',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Otkrijte ljubav kroz zvijezde',
  hero_button_text: 'Započnite svoje putovanje',
  components_ressources_section_title: 'LJUBAV I ASTROLOGIJA',
  components_ressources_subheader_text: 'Vaš nebeski set alata za romantični uvid',
  components_ressources_span_text: 'Zaronite u naš univerzum podcasta i članaka usmjerenih na ljubav, kompatibilnost horoskopskih znakova i kosmičku povezanost. Bez obzira tražite li jasnoću u vezi sa srodnom dušom ili dekodirate obrasce svojih odnosa, naši resursi vas vode do dubljeg razumijevanja kroz zvijezde.',
  components_ressources_card_1_title: 'Ljubavni razgovori sa horoskopskim znakom',
  components_ressources_card_1_text: 'Istražite dirljive epizode podcasta koje istražuju emocionalni jezik svakog znaka, ljubavnu kompatibilnost, strast i lični rast u vezama.',
  components_ressources_card_2_title: 'Ljubavni blog',
  components_ressources_card_2_text: 'Pročitajte uvide i razmišljanja o tome kako svaki znak voli, liječi i povezuje se. Od sinastrije do planetarne romanse, naš blog je vaš vodič za astrološku ljubav.',
  components_ressources_link: 'Istražite dalje',
  components_notes_and_google_title_1: 'Romantična astrologija',
  components_notes_and_google_title_2: 'Ljubavne navike',
  components_notes_and_google_title_3: 'Ljubavne refleksije slušalaca',
  components_review_google_text: 'Šta kažu naši slušaoci',
  media_content_section_title: 'LJUBAV I ZODIJAK PODCAST',
  media_content_section_subheader_text: 'Pravi razgovor o kosmičkoj romansi',
  text_media_1: 'Uključite se u duboke, otkrivajuće epizode o astrološkim podudaranjima, emocionalnim obrascima i romantičnoj dinamici.',
  text_media_2: '',
  media_content_section_button_more: 'Slušajte sada',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Astrološke ljubavne priče i uvidi',
  text2_section_button_more: 'Učitaj više',
  components_text1_section_title: 'VODIČI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Neka zvijezde vode vašu ljubavnu priču',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registarski broj',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Uslovi i odredbe',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj više',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Ljubav i zodijak: Epizode podcasta',
  page_media_content_menu_compatibility: 'Kompatibilnost',
  page_media_content_menu_love: 'Ljubav',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Istražite ljubav kroz astrologiju',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članci',
  enter_email_title: 'Molimo unesite svoju e-mail adresu da biste nastavili',
  enter_email_placeholder_email: 'E-pošta',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava uspješna!',
  components_card_link_media_content: 'Slušajte sada',
  components_card_link_text2_content: 'Čitajte članke',
  components_card_link_text1_content: '',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditacija',
  page_media_content_menu_all: 'Svi',
};